import type { IMfaPasskeyView } from '@shared/services';

const dateFormatter = new Intl.DateTimeFormat(undefined, { dateStyle: 'medium' });

/** Formats an ISO timestamp as a human-readable date, tolerating a malformed value. */
export const formatDate = (iso: string): string => {
  const date = new Date(iso);

  return Number.isNaN(date.getTime()) ? '—' : dateFormatter.format(date);
};

/** A recognizable name for a passkey from its (possibly unknown) device type. */
export const passkeyDeviceLabel = (deviceType: IMfaPasskeyView['deviceType']): string => {
  switch (deviceType) {
    case 'singleDevice':
      return 'Device-bound passkey';
    case 'multiDevice':
      return 'Synced passkey';
    default:
      return 'Passkey';
  }
};

/**
 * The name to show for a passkey: the user-supplied `label` when set, otherwise a name derived from
 * the device type. Trims the label so a whitespace-only value falls back to the device name.
 */
export const passkeyDisplayName = (passkey: Pick<IMfaPasskeyView, 'label' | 'deviceType'>): string =>
  passkey.label?.trim() || passkeyDeviceLabel(passkey.deviceType);
